/* eslint-disable import/no-webpack-loader-syntax */
import React from 'react';
import { KangarooStatus } from '../../../../api/define';

const { useMemo } = React;

type KangarooLogoProps = {
    status: KangarooStatus;
    version: string | null;
};

/** 袋鼠店长 Logo */
const KangarooLogo: React.FC<KangarooLogoProps> = ({ status, version }) => {
    const kanImgUrl = useMemo(() => {
        //预留其它等级图标，目前暂全部使用v3图标
        let imgUrl =
            version === null ? null : require('!url-loader?limit=true!../../assets/kanV3.webp');
        if (status === KangarooStatus.UNEXPIRE || status === KangarooStatus.EXPIRE) {
            if (status === KangarooStatus.EXPIRE) {
                imgUrl = require('!url-loader?limit=true!../../assets/kanOver.webp');
            } else if (version === 'v1') {
                imgUrl = require('!url-loader?limit=true!../../assets/kanV1.webp');
            } else if (version === 'v2') {
                imgUrl = require('!url-loader?limit=true!../../assets/kanV2.webp');
            } else if (version === 'v3') {
                imgUrl = require('!url-loader?limit=true!../../assets/kanV3.webp');
            }
            return imgUrl;
        }
        return null;
    }, [status, version]);

    return <>{kanImgUrl ? <img src={kanImgUrl} /> : null}</>;
};

export default KangarooLogo;
